import { acknowledgePrivacyConsent } from '@/api/login';
import { getLoginRedirect } from '@/utils/index';
import { getUserInfo, removeToken, removeUserInfo, setUserInfo } from '@/utils/auth';

export const PRIVACY_CONSENT_ROLE_KEYS = ['ca', 'participant'];

export default {
  data() {
    return {
      privacyConsentDialogVisible: false,
      privacyConsentSubmitting: false,
      privacyConsentUserInfo: null,
      privacyConsentPostAcceptAction: null,
    };
  },
  methods: {
    isPrivacyConsentApplicable(userInfo) {
      const roleKey = userInfo && userInfo.roles && userInfo.roles[0] && userInfo.roles[0].roleKey;
      return PRIVACY_CONSENT_ROLE_KEYS.includes(roleKey);
    },
    isPrivacyConsentRequired(userInfo) {
      return this.isPrivacyConsentApplicable(userInfo)
        && !!(userInfo && userInfo.privacyConsent && userInfo.privacyConsent.isRequired);
    },
    async maybeRequirePrivacyConsent(userInfo, onAccepted) {
      this.privacyConsentUserInfo = userInfo;
      if (!this.isPrivacyConsentRequired(userInfo)) {
        this.privacyConsentDialogVisible = false;
        this.privacyConsentPostAcceptAction = null;
        return false;
      }

      setUserInfo(userInfo);
      this.privacyConsentPostAcceptAction = typeof onAccepted === 'function' ? onAccepted : null;
      this.privacyConsentDialogVisible = true;
      return true;
    },
    async handlePrivacyConsentConfirm() {
      if (this.privacyConsentSubmitting || !this.privacyConsentUserInfo) {
        return;
      }

      this.privacyConsentSubmitting = true;
      try {
        const res = await acknowledgePrivacyConsent({
          privacyNoticeRead: true,
          personalInfoConsent: true,
          noticeVersion: this.privacyConsentUserInfo.activePrivacyNotice.noticeVersion,
        });
        const previousUserInfo = this.privacyConsentUserInfo || getUserInfo() || {};
        const latestUserInfo = {
          ...res.data,
          originalRoles: previousUserInfo.originalRoles || res.data.roles,
          roles: (previousUserInfo.roles && previousUserInfo.roles.length)
            ? previousUserInfo.roles
            : res.data.roles,
        };
        this.privacyConsentUserInfo = latestUserInfo;
        setUserInfo(latestUserInfo);
        this.privacyConsentDialogVisible = false;

        const postAcceptAction = this.privacyConsentPostAcceptAction;
        this.privacyConsentPostAcceptAction = null;
        if (postAcceptAction) {
          postAcceptAction(latestUserInfo);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.privacyConsentSubmitting = false;
      }
    },
    handlePrivacyConsentCloseAttempt() {
      this.$confirm(
        `<p class="msgbox-body-text">${this.$t('privacyConsentLogoutPrompt')}</p>`,
        {
          dangerouslyUseHTMLString: true,
          customClass: 'tone-vehicle',
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
        },
      )
        .then(() => {
          this.forcePrivacyConsentLogout();
        })
        .catch(() => {
          this.privacyConsentDialogVisible = true;
        });
    },
    getPrivacyLogoutRedirect() {
      if (this.$route && this.$route.path === '/admin') {
        return '/admin';
      }
      if (this.$route && this.$route.path === '/client') {
        return '/client';
      }
      if (this.$route && this.$route.path === '/') {
        return '/';
      }
      if (this.$route && this.$route.path === '/oauthCallback') {
        return '/admin';
      }

      const currentUserInfo = this.privacyConsentUserInfo || getUserInfo();
      const roleKey = currentUserInfo && currentUserInfo.roles && currentUserInfo.roles[0] && currentUserInfo.roles[0].roleKey;
      return getLoginRedirect(roleKey);
    },
    async forcePrivacyConsentLogout() {
      const currentUserInfo = this.privacyConsentUserInfo || getUserInfo();
      const roleKey = currentUserInfo && currentUserInfo.roles && currentUserInfo.roles[0] && currentUserInfo.roles[0].roleKey;

      try {
        await this.$store.dispatch('FedLogOut');
      } catch (error) {
        removeUserInfo();
        removeToken();
      }

      if (roleKey) {
        localStorage.setItem('lastRole', roleKey);
      }
      this.privacyConsentDialogVisible = false;
      this.privacyConsentPostAcceptAction = null;
      this.privacyConsentUserInfo = null;
      this.privacyConsentSubmitting = false;
      this.$router.replace(this.getPrivacyLogoutRedirect());
    },
  },
};
